import PendoAlert from '../../components/alert/pendo-alert.vue.js';
import PendoButton from '../../components/button/pendo-button.vue.js';
import PendoModal from '../../components/modal/pendo-modal.vue.js';
import PendoTable from '../../components/table/pendo-table.vue.js';
import PendoInput from '../../components/input/pendo-input.vue.js';
import PendoIcon from '../../components/icon/pendo-icon.vue.js';

var script = {
  name: 'AddExcludeListStagingItemModal',
  components: {
    PendoAlert,
    PendoButton,
    PendoInput,
    PendoModal,
    PendoTable,
    PendoIcon
  },
  props: {
    hasMoreHosts: {
      type: Boolean,
      required: true,
      default: false
    },
    hosts: {
      type: Array,
      required: true
    },
    hostsLoaded: {
      type: Boolean,
      required: true
    },
    isVisible: {
      type: Boolean,
      required: true,
      default: false
    },
    itemType: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    fetchMyIpAddress: {
      type: Function,
      required: true
    },
    serverHostDomainLabel: {
      type: String,
      default: 'Server Host/Domain'
    },
    stagingModalAlertLink: {
      type: String,
      default: ''
    },
    subHasExtensionApp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bulkHostInput: '',
      columns: [{
        type: 'checkbox'
      }, {
        prop: 'name',
        label: this.serverHostDomainLabel.includes('Server') ? 'Hosts/Domains' : 'Staging Websites',
        sortable: true,
        sortBy: row => row.name.toLowerCase(),
        formatter: row => row.name
      }],
      entryInputValue: '',
      hostsList: [],
      searchInput: '',
      wildcardsList: []
    };
  },
  computed: {
    currentTypeObj() {
      return this.typeMap[this.type] || {};
    },
    filteredHosts() {
      if (this.hosts) {
        return this.hosts.filter(entry => {
          return entry.name !== '';
        });
      }
      return [];
    },
    globType() {
      return this.itemType === 'staging' ? 'stagingGlob' : 'serverGlob';
    },
    isHostType() {
      return this.type === 'server' || this.type === 'staging';
    },
    isGlobType() {
      return this.entryInputValue.includes('*');
    },
    isInvalid() {
      if (this.isHostType) {
        return !this.hostsList.length > 0 && !this.bulkHostInput;
      }
      return !RegExp(this.validationPattern).test(this.entryInputValue);
    },
    itemToAdd() {
      return this.isHostType ? {
        hosts: this.hostsList,
        wildcards: this.wildcardsList
      } : {
        type: this.currentTypeObj.id,
        name: this.entryInputValue
      };
    },
    placeholderText() {
      return this.currentTypeObj.placeholder;
    },
    searchedHosts() {
      if (this.filteredHosts) {
        return this.filteredHosts.filter(host => {
          return host.name.includes(this.searchInput);
        });
      }
      return [];
    },
    title() {
      return `Add ${this.labelIncludesServer ? 'New ' : ''}${this.currentTypeObj.name}`;
    },
    typeMap() {
      return {
        accountId: {
          id: this.isGlobType ? 'accountIdGlob' : 'accountId',
          name: 'Account ID',
          placeholder: 'Example: 65454',
          validationPattern: /^.+$/
        },
        server: {
          id: 'serverGlob',
          name: 'Server Host/Domain',
          placeholder: 'Filter Hosts / Domains',
          validationPattern: /^.+$/
        },
        staging: {
          id: 'stagingGlob',
          name: this.serverHostDomainLabel,
          placeholder: 'Filter Hosts / Domains',
          validationPattern: /^.+$/
        },
        ip: {
          id: this.isGlobType ? 'ipGlob' : 'ip',
          name: 'IP Address',
          placeholder: 'Example: 127.0.0.1',
          validationPattern: /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$|^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/
        },
        visitorId: {
          id: this.isGlobType ? 'visitorIdGlob' : 'visitorId',
          name: 'Visitor ID',
          placeholder: 'Example: *@acme.org, 1337*, or test-*',
          validationPattern: /^[^\[\]\?]+$/
        }
      };
    },
    validationPattern() {
      return this.currentTypeObj.validationPattern;
    },
    labelIncludesServer() {
      return this.serverHostDomainLabel.includes('Server');
    }
  },
  watch: {
    searchInput() {
      if (!this.hasMoreHosts) {
        return;
      }
      return this.$emit('onSearchChange', this.searchInput);
    }
  },
  methods: {
    modalSearchPlaceholder() {
      return this.labelIncludesServer ? 'Hosts/Domains' : 'Staging Websites';
    },
    buildWildcardList() {
      this.wildcardsList = this.bulkHostInput.split(',').map(str => ({
        name: str.trim().replace(/^https?:\/\//, '').replace(/\/.*$/, ''),
        type: this.globType
      }));
    },
    detectIp() {
      return this.fetchMyIpAddress().then(_ref => {
        let {
          data
        } = _ref;
        this.entryInputValue = data;
      });
    },
    onConfirm() {
      if (this.isHostType && this.bulkHostInput) {
        this.buildWildcardList();
      }
      return this.$emit('onConfirm', this.itemToAdd);
    },
    resetState() {
      this.bulkHostInput = '';
      this.entryInputValue = '';
      this.hostsList = [];
      this.searchInput = '';
      this.wildcardsList = [];
    },
    updateHostsList(userSelection) {
      this.hostsList = userSelection.selectedRows;
    }
  }
};

export { script as default };
//# sourceMappingURL=add-exclude-list-staging-item-modal.vue2.js.map
